import React from 'react';
import './style.sass';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallText from '../../../common-components/common-small-text';

const taskPointList = {
    content:
        '<p>Самое сложное в проекте — это тематика с высокой конкуренцией, в которой выбор стратегии внешнего продвижения является одним из ключевых факторов хорошего результата.</p><p>Также в ходе работ возникли трудности с корректностью ответов сервера основных страниц, битыми ссылками и редиректами, низкой скоростью загрузки страниц из-за отсутствия оптимизированных изображений и использования старых форматов.</p>',
};

const Complex = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper className="mts-invest-complex">
                <div className="mts-invest-complex__wrapper">
                    <div className="mts-invest-complex__grid">
                        <div className="mts-invest-complex__content">
                            <CommonTitle className="mts-invest-complex__title">
                                Сложности
                            </CommonTitle>
                            <CommonSmallText className="mts-invest-complex__text">
                                <div dangerouslySetInnerHTML={{ __html: taskPointList.content }} />
                            </CommonSmallText>
                        </div>
                        <div className="mts-invest-complex__img">
                            <img
                                src="/images/svg/mts-invest/mts-invest-complex.svg"
                                alt=""
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Complex;
